import React from 'react';
import { Button, Checkbox, Tooltip } from 'antd';

/**
 * 2D航拍 / 3D建模二级菜单
 */
export default function OrthoKindMenu({
  kind,
  layers,
  canManage,
  busy,
  glbMapActive,
  glbLoading = {},
  ortho2dActive,
  onOpenManage,
  onBeginBboxSelect,
  onCloseMenu,
  onItemCheck,
  onFlyTo2d,
  onFlyTo3d,
  onOpenGlbViewer,
  onAttachGlb,
  onOpenPoseEditor
}) {
  const list = layers || [];
  return (
    <div className="zhxt-map-kind-menu" onMouseDown={(e) => e.stopPropagation()}>
      <div className="zhxt-map-kind-menu-top">
        {canManage ? (
          <Button size="small" type="link" onClick={() => onOpenManage()}>
            管理
          </Button>
        ) : (
          <span className="zhxt-ortho-muted">仅可勾选叠加</span>
        )}
        <Button
          size="small"
          type="link"
          onClick={() => {
            onBeginBboxSelect(kind === '3d' ? 'ortho-3d' : 'ortho-2d');
            onCloseMenu(kind);
          }}
        >
          框选加载
        </Button>
      </div>
      <div className="zhxt-ortho-kind-list">
        {list.length === 0 && (
          <div className="zhxt-ortho-muted" style={{ padding: '8px 0' }}>
            暂无可用正射图层（若后台有成品，请点「管理」或关闭后重开本菜单以刷新）
          </div>
        )}
        {list.map((ly) => {
          const loading = kind === '3d' && !!glbLoading[ly.id];
          const checked = kind === '3d'
            ? !!glbMapActive[ly.id] || loading
            : !!ortho2dActive[ly.id];
          const canToggle = kind === '2d' || !!ly.glbOssKey;
          const tip = String(ly.description || '').trim();
          const label = `${ly.name || `图层 #${ly.id}`}${kind === '3d' && !ly.glbOssKey ? '（未登记3D）' : ''}`;
          const nameBtn = (
            <button
              type="button"
              className="zhxt-ortho-kind-item-name"
              title={tip || '点击定位到区域（不切换叠加）'}
              onClick={() => {
                if (kind === '3d') onFlyTo3d(ly);
                else onFlyTo2d(ly);
              }}
            >
              {label}
            </button>
          );
          return (
            <div key={ly.id} className="zhxt-ortho-kind-item">
              <Checkbox
                checked={checked}
                disabled={!canToggle}
                onChange={(e) => onItemCheck(kind, ly, e.target.checked)}
                onClick={(e) => e.stopPropagation()}
              />
              {loading ? (
                <span className="zhxt-ortho-kind-loading">加载中</span>
              ) : null}
              {tip ? (
                <Tooltip title={tip} placement="right">
                  {nameBtn}
                </Tooltip>
              ) : nameBtn}
              {kind === '3d' && ly.glbOssKey && (
                <Button
                  type="link"
                  size="small"
                  className="zhxt-ortho-kind-item-extra"
                  onClick={() => onOpenGlbViewer(ly)}
                >
                  查看
                </Button>
              )}
              {kind === '3d' && canManage && ly.glbOssKey && (
                <Button
                  type="link"
                  size="small"
                  className="zhxt-ortho-kind-item-extra"
                  onClick={() => onOpenPoseEditor?.(ly)}
                >
                  微调
                </Button>
              )}
              {kind === '3d' && canManage && !ly.glbOssKey && (
                <Button
                  type="link"
                  size="small"
                  className="zhxt-ortho-kind-item-extra"
                  loading={busy}
                  onClick={() => onAttachGlb(ly)}
                >
                  登记
                </Button>
              )}
            </div>
          );
        })}
      </div>
      <div className="zhxt-ortho-muted" style={{ fontSize: 11, marginTop: 6 }}>
        {kind === '3d'
          ? '勾选即可叠加（先出轮廓再补细节）；点名称定位；加载中仍可勾其它项'
          : '勾选：叠加正射；点名称：仅定位到范围'}
      </div>
    </div>
  );
}
